import axios from "axios";

/**
 * Базовый URL API.
 *
 * На тенант-хосте <ws>.<base> (где <base> — один из
 * REACT_APP_WORKSPACE_BASE_DOMAINS) фронт бьёт в api.<ws>.<base>, поэтому один
 * и тот же билд работает на любом сабдомене любого бренда (listli.ru,
 * edskills.by). На легаси-хостах бренда (<base>, app.<base>, www.<base>) фронт
 * бьёт по HTTPS в api.<base>. Для остальных хостов используется статический
 * REACT_APP_API_URL.
 */
export function resolveApiBaseUrl(): string {
  const fallback = process.env.REACT_APP_API_URL || "";

  if (typeof window === "undefined") {
    return fallback;
  }

  const bases = (process.env.REACT_APP_WORKSPACE_BASE_DOMAINS || "")
    .split(",")
    .map((d) => d.trim().toLowerCase())
    .filter(Boolean);

  const host = window.location.hostname.toLowerCase();
  // Функц-лейблы и легаси-сабдомены, которые НЕ являются workspace.
  const reserved = new Set(["app", "www", "api", "admin"]);

  for (const base of bases) {
    const suffix = "." + base;
    if (host === base || host === `app.${base}` || host === `www.${base}`) {
      return `https://api.${base}`;
    }
    if (!host.endsWith(suffix)) {
      continue;
    }
    const ws = host.slice(0, -suffix.length);
    // Ровно один лейбл (<ws>.<base>) и не зарезервированный.
    if (ws && !ws.includes(".") && !reserved.has(ws)) {
      return `${window.location.protocol}//api.${ws}.${base}`;
    }
  }

  return fallback;
}

const axiosInstance = axios.create({
  baseURL: resolveApiBaseUrl(),
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) =>
    Promise.reject(
      (error.response && error.response.data) || "Something went wrong"
    )
);

export default axiosInstance;
